<button
    class="textarea-actions__button"
    type="button"
    [attr.aria-label]="copyAriaLabel | translate"
    [attr.title]="copyAriaLabel | translate"
    (mousedown)="keepFocus($event)"
    (click)="onCopy($event)">
    <fa-icon [icon]="['fas', isCopied ? 'check' : 'copy']"></fa-icon>
</button>
<button
    class="textarea-actions__button"
    type="button"
    [attr.aria-expanded]="expanded"
    [attr.aria-label]="toggleAriaLabel | translate"
    [attr.title]="toggleAriaLabel | translate"
    (mousedown)="keepFocus($event)"
    (click)="onToggle($event)">
    <fa-icon [icon]="['fas', expanded ? 'chevron-up' : 'info-circle']"></fa-icon>
</button>
